import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';
import Moment from 'react-moment';

import {
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
  Form,
  FormGroup,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardText,
  CardTitle,
  CardSubtitle,
  Spinner,
} from 'reactstrap';

import FileUploader from "react-firebase-file-uploader";

import { connect } from 'react-redux';

import {
  getCampaignsFiltered,
  updateFeaturedCampaign,
  updateTopPickCampaign,
} from '../../../actions/admin';

class FeaturedCampaigns extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    admin: PropTypes.shape(),
    fetchCampaignsFiltered: PropTypes.func.isRequired,
    changeFeaturedCampaign: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    admin: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      enabled: false,
      deleteSettingModal: false,
      deleteSettingErr: null,
      settingToDelete: null,
      activeTab: '1',
      companyNotification: '',
      allChecked: true,
      checked: {},
      featuredCampaigns: [],
      featuredCampaignsIds: [],
      companyInformation: '',
    };
  }

  componentDidMount() {
    const { fetchCampaignsFiltered, user, isLoggedIn, history } = this.props;

    if (user && Object.keys(user).length > 0) {
      if (!user || !isLoggedIn || !user || !user.roleClass || user.roleClass !== 'admin') {
        history.push('/');
      } else {
        fetchCampaignsFiltered('created_at', 'descending', null, 'all', null, null).then((res) => {
          const { voucherCampaigns } = this.props;

          console.log('voucherCampaigns', voucherCampaigns);

          let featuredCampaigns = [];
          let featuredCampaignsIds = [];
          let topPickCampaign;

          if (voucherCampaigns) {
            voucherCampaigns.map((voucher) => {
              const { featured, topPick } = voucher;

              if (featured) {
                featuredCampaigns.push({ ...voucher, key: voucher.id });
                featuredCampaignsIds.push(voucher.id);
              }

              if (topPick) {
                topPickCampaign = { ...voucher, key: voucher.id };
              }
            });
          }

          console.log('featuredCampaigns', featuredCampaigns);

          this.setState({ featuredCampaigns, featuredCampaignsIds, topPickCampaign });
        });
      }
    } else {
      history.push('/');
    }
  }

  fetchPerks = () => {
    const { fetchPerks } = this.props;

    fetchPerks().then((res2) => {
      let perks = {};

      console.log('fetchPerks', res2);
      if (res2) {
        Object.keys(res2).map((key, index) => {
          perks[key] = res2[key];
          return null;
        });
      }

      this.setState({ perks });
    })
  }

  openEditPerk = (e, id) => {
    e.preventDefault();
    const { perks } = this.state;

    if (perks && perks[id]) {
      const perk = perks[id];

      console.log('perk', perk, id);

      // newName, newLink, newDescription, newSummary, newImage

      this.setState({
        editPerkModal: true,
        newName: perk.name,
        newLink: perk.link,
        newDescription: perk.description,
        newSummary: perk.summary,
        newImage: perk.image,
        editId: id,
      });
    }
  }

  goToLink = (link) => {
    const { history } = this.props;

    console.log('goToLink', link);

    window.open(link, '_blank').focus();
  }

  openChangeFeaturedCampaign = (currentFeaturedCampaignId) => {
    this.setState({ currentFeaturedCampaignId, openEditModal: true, newCampaignId: null });
  }

  closeChangeFeaturedCampaign = () => {
    this.setState({ currentFeaturedCampaignId: null, openEditModal: null, newCampaignId: null });
  }

  saveChangeFeaturedCampaign = async () => {
    const { changeFeaturedCampaign, fetchCampaignsFiltered } = this.props;
    const { currentFeaturedCampaignId, newCampaignId } = this.state;

    console.log('saveChangeFeaturedCampaign', currentFeaturedCampaignId, newCampaignId);

    this.setState({ editSpinner: true });

    if (currentFeaturedCampaignId) {
      await changeFeaturedCampaign(currentFeaturedCampaignId, null);
    }

    if (newCampaignId) {
      await changeFeaturedCampaign(newCampaignId, true);
    }
    

    fetchCampaignsFiltered('created_at', 'descending', null, 'all', null, null).then((res) => {
      const { voucherCampaigns } = this.props;

      let featuredCampaigns = [];
      let featuredCampaignsIds = [];

      if (voucherCampaigns) {
        voucherCampaigns.map((voucher) => {
          const { featured } = voucher;

          if (featured) {
            featuredCampaigns.push({ ...voucher, key: voucher.id });
            featuredCampaignsIds.push(voucher.id);
          }
        });
      }

      console.log('featuredCampaigns', featuredCampaigns);

      this.setState({ editSpinner: true, featuredCampaigns, featuredCampaignsIds, currentFeaturedCampaignId: null, openEditModal: null, newCampaignId: null });
    });
  }

  handleChangeCampaign = (e) => {
    const campaignId = e.target.value;

    if (campaignId) {
      this.setState({ newCampaignId: campaignId });
    } else {
      this.setState({ newCampaignId: null });
    }
  }



  openChangeTopPickCampaign = (currentTopPickCampaignId) => {
    console.log('openChangeTopPickCampaign', currentTopPickCampaignId);
    this.setState({ currentTopPickCampaignId, openEditTopPickModal: true, newTopPickCampaignId: null });
  }

  closeChangeTopPickCampaign = () => {
    this.setState({ currentTopPickCampaignId: null, openEditTopPickModal: null, newTopPickCampaignId: null });
  }

  saveChangeTopPickCampaign = async () => {
    const { changeTopPickCampaign, fetchCampaignsFiltered } = this.props;
    const { currentTopPickCampaignId, newTopPickCampaignId } = this.state;

    console.log('saveChangeTopPickCampaign', currentTopPickCampaignId, newTopPickCampaignId);

    this.setState({ editSpinner: true });

    if (currentTopPickCampaignId) {
      await changeTopPickCampaign(currentTopPickCampaignId, null);
    }

    if (newTopPickCampaignId) {
      await changeTopPickCampaign(newTopPickCampaignId, true);
    }


    fetchCampaignsFiltered('created_at', 'descending', null, 'all', null, null).then((res) => {
      const { voucherCampaigns } = this.props;

      let topPickCampaign;

      if (voucherCampaigns) {
        voucherCampaigns.map((voucher) => {
          const { topPick } = voucher;

          if (topPick) {
            topPickCampaign = { ...voucher, key: voucher.id };
          }
        });
      }

      console.log('topPickCampaign', topPickCampaign);

      this.setState({ editSpinner: true, topPickCampaign, currentTopPickCampaignId: null, openEditTopPickModal: null, newTopPickCampaignId: null });
    });
  }

  handleChangeTopPickCampaign = (e) => {
    const campaignId = e.target.value;

    if (campaignId) {
      this.setState({ newTopPickCampaignId: campaignId });
    } else {
      this.setState({ newTopPickCampaignId: null });
    }
  }

  render() {
    const { emailSettings, user, voucherCampaigns } = this.props;
    const {
      activeTab,
      error,
      newName,

      editSpinner,
      featuredCampaigns,
      featuredCampaignsIds,
      currentFeaturedCampaignId,
      openEditModal,
      newCampaignId,

      openTopPickModal,
      topPickCampaign,
      currentTopPickCampaignId,
      openEditTopPickModal,
      newTopPickCampaignId,
    } = this.state;

    if (!user.role || user.roleClass !== 'admin') {
      return (
        <div>
          <Card>
            <CardBody>
              You need admin permissions to view Email settings
            </CardBody>
          </Card>
        </div>
      );
    }

    console.log('featuredCampaigns', featuredCampaigns, featuredCampaignsIds);

    return (
      <div>
        <TabContent activeTab="1">
          <TabPane tabId="1">
            <Row>
              <Col xs="3" style={{ height: 140 }}>
                <Card
                  className="perks-card"
                  onClick={() => (featuredCampaigns && featuredCampaigns[0]) ? this.openChangeFeaturedCampaign(featuredCampaigns[0].key) : this.openChangeFeaturedCampaign(null)}
                >
                  <CardBody style={{ background: '#6FC0F9', minheight: 120 }}>
                    <CardTitle tag="h5" style={{ color: '#FFF', textDecoration: 'none' }}>
                      <div style={{ color: '#FFF', textDecoration: 'none' }}>
                        {featuredCampaigns[0] ? `Campaign - ${featuredCampaigns[0].name}` : ''}
                      </div>
                    </CardTitle>
                    <CardSubtitle
                      style={{ color: '#FFF' }}
                      className="mb-2"
                      tag="h6"
                    >
                      {featuredCampaigns[0] ? `Company - ${featuredCampaigns[0].companyName}` : ''}
                    </CardSubtitle>
                    <CardText style={{ color: '#FFF', fontWeight: 'bold' }}>
                      {featuredCampaigns[0] ? `Campaign is ${featuredCampaigns[0].status === 1 ? 'Live' : 'Stopped'}` : ''}
                    </CardText>
                  </CardBody>
                </Card>
                {/*{(featuredCampaigns && featuredCampaigns[0]) ? (
                   <div onClick={() => this.openChangeFeaturedCampaign(featuredCampaigns[0].key)}>
                      <div>Name: {featuredCampaigns[0].name}</div>
                      <div>Company name: {featuredCampaigns[0].companyName}</div>
                      <div>Status: {featuredCampaigns[0].status === 1 ? 'Live' : 'Stopped'}</div>
                    </div>
                ) : (<div onClick={() => this.openChangeFeaturedCampaign(null)} style={{ width: '100%', height: '100%' }} />)} */}
              </Col>
              <Col xs="3" style={{ height: 140 }}>
                <Card
                  className="perks-card"
                  onClick={() => (featuredCampaigns && featuredCampaigns[1]) ? this.openChangeFeaturedCampaign(featuredCampaigns[1].key) : this.openChangeFeaturedCampaign(null)}
                >
                  <CardBody style={{ background: '#6FC0F9', minheight: 120 }}>
                    <CardTitle tag="h5" style={{ color: '#FFF', textDecoration: 'none' }}>
                      <div style={{ color: '#FFF', textDecoration: 'none' }}>
                        {featuredCampaigns[1] ? `Campaign - ${featuredCampaigns[1].name}` : ''}
                      </div>
                    </CardTitle>
                    <CardSubtitle
                      style={{ color: '#FFF' }}
                      className="mb-2"
                      tag="h6"
                    >
                      {featuredCampaigns[1] ?`Company - ${featuredCampaigns[1].companyName}` : ''}
                    </CardSubtitle>
                    <CardText style={{ color: '#FFF', fontWeight: 'bold' }}>
                      {featuredCampaigns[1] ?`Campaign is ${featuredCampaigns[1].status === 1 ? 'Live' : 'Stopped'}` : ''}
                    </CardText>
                  </CardBody>
                </Card>
                {/* {(featuredCampaigns && featuredCampaigns[1]) ? (
                   <div onClick={() => this.openChangeFeaturedCampaign(featuredCampaigns[1].key)}>
                    <div>Name: {featuredCampaigns[1].name}</div>
                    <div>Company name: {featuredCampaigns[1].companyName}</div>
                    <div>Status: {featuredCampaigns[1].status === 1 ? 'Live' : 'Stopped'}</div>
                  </div>
                ) : (<div onClick={() => this.openChangeFeaturedCampaign(null)} style={{ width: '100%', height: '100%' }} />)} */}
              </Col>
              <Col xs="3" style={{ height: 140 }}>
                <Card
                  className="perks-card"
                  onClick={() => (featuredCampaigns && featuredCampaigns[2]) ? this.openChangeFeaturedCampaign(featuredCampaigns[2].key) : this.openChangeFeaturedCampaign(null)}
                >
                  <CardBody style={{ background: '#6FC0F9', minheight: 120 }}>
                    <CardTitle tag="h5" style={{ color: '#FFF', textDecoration: 'none' }}>
                      <div style={{ color: '#FFF', textDecoration: 'none' }}>
                        {featuredCampaigns[2] ? `Campaign - ${featuredCampaigns[2].name}` : ''}
                      </div>
                    </CardTitle>
                    <CardSubtitle
                      style={{ color: '#FFF' }}
                      className="mb-2"
                      tag="h6"
                    >
                      {featuredCampaigns[2] ? `Company - ${featuredCampaigns[2].companyName}` : ''}
                    </CardSubtitle>
                    <CardText style={{ color: '#FFF', fontWeight: 'bold' }}>
                      {featuredCampaigns[2] ? `Campaign is ${featuredCampaigns[2].status === 1 ? 'Live' : 'Stopped'}` : ''}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col xs="3" style={{ height: 140 }}>
                <Card
                  className="perks-card"
                  onClick={() => (featuredCampaigns && featuredCampaigns[3]) ? this.openChangeFeaturedCampaign(featuredCampaigns[3].key) : this.openChangeFeaturedCampaign(null)}
                >
                  <CardBody style={{ background: '#6FC0F9', minheight: 120 }}>
                    <CardTitle tag="h5" style={{ color: '#FFF', textDecoration: 'none' }}>
                      <div style={{ color: '#FFF', textDecoration: 'none' }}>
                        {featuredCampaigns[3] ? `Campaign - ${featuredCampaigns[3].name}` : ''}
                      </div>
                    </CardTitle>
                    <CardSubtitle
                      style={{ color: '#FFF' }}
                      className="mb-2"
                      tag="h6"
                    >
                      {featuredCampaigns[3] ? `Company - ${featuredCampaigns[3].companyName}` : ''}
                    </CardSubtitle>
                    <CardText style={{ color: '#FFF', fontWeight: 'bold' }}>
                      {featuredCampaigns[3] ? `Campaign is ${featuredCampaigns[3].status === 1 ? 'Live' : 'Stopped'}` : ''}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col xs="3" style={{ height: 140 }}>
                <Card
                  className="perks-card"
                  onClick={() => (topPickCampaign && topPickCampaign.key) ? this.openChangeTopPickCampaign(topPickCampaign.key) : this.openChangeTopPickCampaign(null)}
                >
                  <CardBody style={{ background: '#6FC0F9', minheight: 120 }}>
                    <CardTitle tag="h5" style={{ color: '#FFF', textDecoration: 'none' }}>
                      <div style={{ color: '#FFF', textDecoration: 'none' }}>
                        {topPickCampaign ? `Campaign - ${topPickCampaign.name}` : ''}
                      </div>
                    </CardTitle>
                    <CardSubtitle
                      style={{ color: '#FFF' }}
                      className="mb-2"
                      tag="h6"
                    >
                      {topPickCampaign ? `Company - ${topPickCampaign.companyName}` : ''}
                    </CardSubtitle>
                    <CardText style={{ color: '#FFF', fontWeight: 'bold' }}>
                      {topPickCampaign ? `Campaign is ${topPickCampaign.status === 1 ? 'Live' : 'Stopped'}` : ''}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>
        </TabContent>

        <Modal isOpen={openEditModal} toggle={this.closeChangeFeaturedCampaign}>
          <ModalHeader toggle={this.closeChangeFeaturedCampaign}>
            Create Featured Campaign
          </ModalHeader>
          <ModalBody>
            {(!!error) && <Alert color="danger">{error}</Alert>}
            <FormGroup>
              <Label for="companyId">
                New campaign to show
              </Label>
              <Input type="select" id="companyId" className="form-control" value={newCampaignId} onChange={(e) => this.handleChangeCampaign(e)}>
                <option value={null}>None</option>
                {voucherCampaigns.map((voucher) => {
                  if (voucher && voucher.status === 1 && !featuredCampaignsIds.includes(voucher.id)) {
                    return (
                      <option value={voucher.id}>{`${voucher.companyName} - ${voucher.name}`}</option>
                    )
                  }
                })}
              </Input>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveChangeFeaturedCampaign}>
              Update
              {editSpinner ? (
                <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
              ) : (null)}
            </Button>
            <Button color="secondary" onClick={this.closeChangeFeaturedCampaign}>Close</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={openEditTopPickModal} toggle={this.closeChangeTopPickCampaign}>
          <ModalHeader toggle={this.closeChangeTopPickCampaign}>
            Change Top Pick Campaign
          </ModalHeader>
          <ModalBody>
            {(!!error) && <Alert color="danger">{error}</Alert>}
            <FormGroup>
              <Label for="companyId">
                New campaign to show
              </Label>
              <Input type="select" id="companyId" className="form-control" value={newCampaignId} onChange={(e) => this.handleChangeTopPickCampaign(e)}>
                <option value={null}>None</option>
                {voucherCampaigns.map((voucher) => {
                  if (voucher && voucher.status === 1 && (!topPickCampaign || (voucher.id !== topPickCampaign.key))) {
                    return (
                      <option value={voucher.id}>{`${voucher.companyName} - ${voucher.name}`}</option>
                    )
                  }
                })}
              </Input>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveChangeTopPickCampaign}>
              Update
              {editSpinner ? (
                <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
              ) : (null)}
            </Button>
            <Button color="secondary" onClick={this.closeChangeTopPickCampaign}>Close</Button>
          </ModalFooter>
        </Modal>
        
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  isLoggedIn: state.user.isLoggedIn || false,
  emailSettings: state.notifications.emailSettings || {},
  adminsRoles: state.admin.adminsRoles || {},
  voucherCampaigns: state.admin.voucherCampaigns || [],
});

const mapDispatchToProps = {
  fetchCampaignsFiltered: getCampaignsFiltered,
  changeFeaturedCampaign: updateFeaturedCampaign,
  changeTopPickCampaign: updateTopPickCampaign,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FeaturedCampaigns));
